import { useQuery, UseQueryResult } from 'react-query';
import { FilterDto, FilterItemDto, getFilters } from '@creditsights/api-ui-web';
import { queryKeys } from '../queryKeyFactory';

export default (filterType: string): UseQueryResult<FilterItemDto[], Error> => {
  return useQuery<FilterDto[], Error, FilterItemDto[]>(queryKeys.fetchFilters.options(filterType), getFilters, {
    select(dtos) {
      return dtos.find((dto) => dto.type === filterType)?.options || [];
    },
  });
};
